import { makeStyles, DialogTitle, IconButton, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import type { QuoteDocument } from 'paintscout'
import { getLineItem } from '@paintscout/util/src/builder/quote/line-items/get-line-item/get-line-item'
import React from 'react'
import get from 'lodash/get'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles<Theme, EditLineItemDialogHeaderProps>(
  (theme) => ({
    root: {
      padding: theme.spacing(2),
      '& > div': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }
    },
    areaLabel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& h4': {
        marginRight: theme.spacing(),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }
    },
    leftContent: {
      width: '100%'
    },
    rightContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      width: '100%',
      paddingLeft: theme.spacing(),
      '& h4': {
        marginBottom: theme.spacing() / 4
      }
    },
    rightContentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: theme.spacing(1)
    },
    closeButton: {
      alignSelf: 'flex-end'
    },
    totalHours: {
      color: theme.paintscout.palette.brand.Neutral.P75
    }
  }),
  { name: 'EditLineItemDialogHeader' }
)

export interface EditLineItemDialogHeaderProps {
  classes?: StyleClasses<typeof useStyles>
  itemKey: string
  quote: QuoteDocument
  onCancel?: () => void
  loading?: boolean
}

function EditLineItemDialogHeader(props: EditLineItemDialogHeaderProps) {
  const classes = useStyles(props)
  const { quote, itemKey, onCancel, loading } = props
  const item = getLineItem({ quote, key: itemKey })

  const totalHours = Number(item.hours)
  const priceValue = get(item, 'totals.afterMaterials', item.price)

  const rightContent = (
    <div className={classes.rightContentWrapper}>
      {onCancel && (
        <IconButton size="small" onClick={onCancel} disabled={loading} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      )}
      <div className={classes.rightContent}>
        {!!priceValue && <Typography variant="h4" value={priceValue} format={'price'} showUnits={true} />}
        {!!item.hours && (
          <Typography
            variant="h4"
            classes={{ root: classes.totalHours }}
            value={totalHours}
            format={'hours'}
            showUnits={true}
          />
        )}
      </div>
    </div>
  )

  return (
    <DialogTitle classes={{ root: classes.root }} rightContent={rightContent} loading={loading}>
      <div className={classes.leftContent}>
        <div className={classes.areaLabel}>
          <Typography variant="h3" className={classes.areaLabel}>
            <span>Edit Line Item</span>
          </Typography>
        </div>
      </div>
    </DialogTitle>
  )
}

export default EditLineItemDialogHeader
